import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Select from '@mui/material/Select'

import { useQuery } from '~/client/hooks/cqrpc'

export default function DocumentTypeInput({
  fullWidth,
  label,
  value,
  onChange,
  ...props
}){
  const [labelId] = React.useState(`${Math.random()}`)
  const query = useQuery('documentTypes.getAll')
  const types = query.result || []
  return <FormControl {...{
    fullWidth,
    error: !!query.error,
    sx: { minWidth: 200 },
  }}>
    <InputLabel id={labelId}>{label}</InputLabel>
    <Select {...{
      ...props,
      variant: 'standard',
      labelId,
      disabled: props.disabled || query.pending,
      value: value || '',
      onChange(e){ onChange(e.target.value, e) },
    }}>
      {types.map(type =>
        <MenuItem key={type.id} value={type.id}>
          {type.name}
        </MenuItem>
      )}
    </Select>
    {query.error ? <FormHelperText>error loading document types</FormHelperText> : null}
  </FormControl>
}
